var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M22.0001 3.41L21.8801 2.15L20.6801 2.55C18.6235 3.26454 16.4273 3.48382 14.2701 3.19C12.0032 2.83821 9.68298 3.15082 7.59006 4.09C6.48054 4.56245 5.50681 5.30491 4.75754 6.24981C4.00826 7.1947 3.50723 8.31201 3.30006 9.5C3.03144 11.0347 3.16582 12.6128 3.69006 14.08C4.02761 13.3181 4.42206 12.5827 4.87006 11.88C5.88626 10.3848 7.29434 9.19818 8.94006 8.45C10.5255 7.72612 12.2584 7.38365 14.0001 7.45C12.3421 7.7035 10.7551 8.29948 9.34006 9.2C8.65753 9.62885 8.03249 10.143 7.48006 10.73C6.95172 11.3167 6.48588 11.9568 6.09006 12.64C5.34659 14.068 4.81758 15.5978 4.52006 17.18C4.19937 18.7673 4.02531 20.3808 4.00006 22H6.00006C6.09406 20.5478 6.29122 19.1042 6.59006 17.68C7.97749 18.4292 9.53341 18.8113 11.1101 18.79C12.5805 18.789 14.0359 18.4932 15.3901 17.92C23.0001 14.67 22.0001 3.86 22.0001 3.41Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }